import useTransferNews from "../hooks/transfer-news/useTransferNews";
import TransferNewsSection from "../components/transfer-news/TransferNewsSection";
import TopNewsCarousel from "../components/transfer-news/TopNewsCarousel";

const TransferNews = () => {
  const {
    // Top news state
    topNews,
    isLoadingTopNews,
    topNewsError,

    // Shared data
    positions,
    countries,

    // Navigation handlers
    handlePlayerClickNavigate,
    handleClubClickNavigate,
    handleNewsClick,

    // Localisation
    apiLanguage,
    changeLanguage,

    // Utility
    fetchTopNews,
  } = useTransferNews();

  return (
    <div className="mx-auto pb-8">
      {/* Top Transfer News Section */}
      <TransferNewsSection
        title="Top Transfer News"
        sortType="top"
        positions={positions}
        countries={countries}
        handlePlayerClickNavigate={handlePlayerClickNavigate}
        handleClubClickNavigate={handleClubClickNavigate}
      />

      {/* Recent Transfer News Section */}
      <TransferNewsSection
        title="Recent Transfer News"
        sortType="recent"
        positions={positions}
        countries={countries}
        handlePlayerClickNavigate={handlePlayerClickNavigate}
        handleClubClickNavigate={handleClubClickNavigate}
      />

      {/* Top News Section */}
      <TopNewsCarousel
        isLoadingTopNews={isLoadingTopNews}
        topNewsError={topNewsError}
        topNews={topNews}
        fetchTopNews={fetchTopNews}
        handleNewsClick={handleNewsClick}
        apiLanguage={apiLanguage}
        changeLanguage={changeLanguage}
      />
    </div>
  );
};

export default TransferNews;
